import * as React from 'react';
import { AuthGateApiClient } from '../Api/ApiServerHooks';
import { useGateApi } from '../Api/useGateApi';
import { useNavigate } from 'react-router';

export interface IProtectedRouteProps {
    children: React.ReactNode;
}

export default function ProtectedRoute(props: IProtectedRouteProps) {
    const { authorizedApi } = useGateApi(AuthGateApiClient);
    const [authed, setAuthed] = React.useState(false);
    const navigate = useNavigate();
    React.useEffect(() => {
        if (localStorage.getItem('token') === null) {
            setAuthed(false);
            navigate('/');
        }
        if (authorizedApi === null) return;

        authorizedApi?.isAuthed().then(() => {
            setAuthed(true);
        }).catch(() => {
            setAuthed(false);
            navigate('/');
        })

    }, [authorizedApi, navigate]);
    return (
        <div>
            {authed && props.children}
        </div>
    );
}
